import React from "react";
import AddCity from "../Components/City/addCity";
import EditCity from "../Components/City/editCity";
import ListCity from "../Components/City/listCity";
import ViewCity from "../Components/City/viewCity";
import { Routes, Route } from "react-router-dom";
import ListCountryState from "../Components/State/listCountryState";
const CityRoutes = () => {
  return (
    <Routes>
      <Route path="/city" element={<ListCountryState></ListCountryState>}></Route>
      <Route path="/city/:id" element={<ListCity></ListCity>}></Route>
      <Route path="/city/edit/:id" element={<EditCity></EditCity>}></Route>
      <Route path="/city/:id/add" element={<AddCity></AddCity>}></Route>
      <Route path="/city/view/:id" element={<ViewCity></ViewCity>}></Route>
    </Routes>
  );
};

export default CityRoutes;
